import { createSlice } from '@reduxjs/toolkit'

/**
 * Регион, в разрезе которого работают все модули.
 *
 * ПАНЕЛЬ ПРИБИТА К АТЫРАУСКОЙ ОБЛАСТИ. Исходный планшет — панель
 * республиканского уровня, и регион в нём выбирался руками (по умолчанию стояла
 * Астана). Здесь панель областная: подставлять руководителю области сначала
 * чужой регион, а потом ждать, что он переключит фильтр, — значит показывать
 * заведомо не те цифры на первом экране.
 *
 * ХРАНИТСЯ НАЗВАНИЕ, А НЕ `region_id`, И ЭТО ВАЖНО. У унаследованных справочников нет единой
 * нумерации регионов — их как минимум две, и Атырау в них разная:
 *
 *   - `13` — справочник модуля преступности (`data/crimeStatisticsV2Data.ts`),
 *     туда уходят запросы `/erdr/sequence/*`;
 *   - `37` (код `1923`) — справочник `/regions`, по нему резолвят регион розыск
 *     (`StateSearchModule`) и административные нарушения.
 *
 * Поэтому единой константы `REGION_ID` здесь нет: она была бы верна ровно для
 * одного семейства эндпоинтов и молча ломала бы остальные. Каждый модуль сам
 * переводит название в свой идентификатор — название и есть общий язык.
 *
 * СПРАВОЧНИКИ ВСЕХ ДВАДЦАТИ ОБЛАСТЕЙ ТРОГАТЬ НЕ НАДО. Атырау уже лежит в каждом
 * из них как обычный регион страны — с идентификаторами выше, координатами в
 * `KazakhstanMap` и местом в `utils/sortByPriority`. Переименовать в них
 * Кызылорду значило бы завести второй Атырау и потерять настоящую Кызылорду:
 * панель показывает и сравнение по стране, и чужие регионы ей нужны целыми.
 */
import { ATYRAU_ALL } from '@/constants/atyrauDistricts'

export const REGION_NAME = 'Атырауская область'

interface GlobalFiltersState {
  selectedRegion: string
}

/**
 * ПО УМОЛЧАНИЮ ВЫБРАНА ВСЯ ОБЛАСТЬ, А НЕ ЕЁ НАЗВАНИЕ, и это исправление, а не
 * вкусовщина. Модули сравнивают выбранную территорию со строкой «Вся область»
 * — это их признак «фильтр снят». Здесь же лежало `REGION_NAME`, то есть
 * «Атырауская область»: строки не совпадали, фильтр считался выставленным, и
 * экран отбирал проекты по несуществующей территории с таким названием. Так
 * «Инвесторы и проекты» открывались с нулём при двадцати восьми проектах в
 * наборе.
 */
const initialState: GlobalFiltersState = {
  selectedRegion: ATYRAU_ALL,
}

export const globalFiltersSlice = createSlice({
  name: 'global-filters',
  initialState,
  reducers: {
    setSelectedRegion: (state, action) => {
      state.selectedRegion = action.payload
    },
  },
})

export const globalFiltersActions = globalFiltersSlice.actions
export default globalFiltersSlice.reducer
